export const OWA_AUTO_LINKS_CLASSNAME = 'OWAAutoLink';
export const LINK_CONTEXT_MENU = 'LinkContextMenu';
export const SPAN_TAG_NAME = 'SPAN';
export const SAFELINK_ORIGINALSRC_ATTRIBUTE_NAME = 'originalsrc';
export const ANCHOR_TAG_NAME_LOWER_CASE = 'a';
export const CONTEXT_MENU_EVENT_NAME = 'contextmenu';
export const CLICK_EVENT_NAME = 'click';
export const ATTRIBUTE_STYLE_NAME = 'style';
export const ATTRIBUTE_CONTENTEDITABLE_NAME = 'contenteditable';
export const STYLE_SEPARATOR = ';';
